// extracted by mini-css-extract-plugin
module.exports = {"xieyi":"Checkbox_xieyi__GmEfG","checkbox":"Checkbox_checkbox__IPT13","checked":"Checkbox_checked__ewEWf","text":"Checkbox_text__a67Df"};